import cn from "classnames";

import type { ContainerBuilderBlock } from "@/components/containerBuilder/containerBuilder.component";
import { RichText } from "@/components/richText/richText.component";

/**
 * Page builder block for a standalone run of rich text.
 *
 * `alignment` sets the default for the block; the per-line align marks authors
 * can apply inside the editor still win over it, since those render their own
 * alignment wrappers.
 */
export function TextBuilder({ block }: TextBuilderProps) {
  if (!block?.content?.length) return null;
  const direction = block.direction ?? "column";
  const alignment = block.alignment ?? "left";
  return (
    <section
      data-testid="text-builder"
      className={cn("flex", {
        "flex-col": direction === "column",
        "flex-row": direction === "row",
        "justify-start": alignment === "left",
        "justify-center": alignment === "center",
        "justify-end": alignment === "right",
      })}>
      <RichText>{block.content}</RichText>
    </section>
  );
}

type ContainerChild = NonNullable<ContainerBuilderBlock["children"]>[number];

export type TextBuilderBlock = Extract<
  ContainerChild,
  { _type: "textBuilder" }
>;

type TextBuilderProps = {
  block: TextBuilderBlock;
};
